import React, { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import AffiliateOverallPage from './affiliate/AffiliateOverallPage'
import AffiliateMemberPage from './affiliate/AffiliateMemberPage'
import AffiliateIncomePage from './affiliate/AffiliateIncomePage'
import AffiliateTopTenPage from './affiliate/AffiliateTopTenPage'

const AffiliatePage: React.FC = () => {
  const navigate = useNavigate()
  
  // Tab state
  const [activeTab, setActiveTab] = useState('overall')
  
  
  return (
    <div className="content pb-3">
      <div className="container">
        <div className="row px--1">
          <div className="col-12 px-1">
            <div className="bdr-5 bx-sd mb-2">
              <div className="row mx--1">
                <div className="col-12 px-1">
                  <div className="w-100 p-2 bgc-4 wrap justify-content-between">
                    <a href='#'
                      className="txt-link-d"
                      onClick={() => navigate('/dashboard')}
                    >
                      <i className="fas fa-chevron-left me-1"></i>
                      หน้าหลัก
                    </a>
                  </div>
                </div>
                
                <div className="col-12 px-1">
                  <div className="w-100 p-2 bgc-7">
                    <div className="bdr-5 bgc-4 c-red px-2 py-1 fs-18 t-medium mb-2">
                      <i className="fas fa-sitemap me-2"></i>
                      แนะนำเพื่อน
                    </div>
                    
                    <div className="row mx--1">
                      <div className="col-12 px-1 mb-2">
                        <div className="nav nav-pills nav-pills-ticket mx--1" role="tablist">
                          <div className={`nav-link col px-1 py-0 ${activeTab === 'overall' ? 'active' : ''}`}>
                            <button
                              className={`check-button w-100 d-block border-0 ${
                                activeTab === 'overall' ? 'bgg-5 c-white' : 'bgc-4 c-dark'
                              }`}
                              onClick={() => setActiveTab('overall')}
                            >
                              <h4><i className="fas fa-th"></i></h4>
                              <p>ภาพรวม</p>
                            </button>
                          </div>
                          <div className={`nav-link col px-1 py-0 ${activeTab === 'member' ? 'active' : ''}`}>
                            <button
                              className={`check-button w-100 d-block border-0 ${
                                activeTab === 'member' ? 'bgg-5 c-white' : 'bgc-4 c-dark'
                              }`}
                              onClick={() => setActiveTab('member')}
                            >
                              <h4><i className="fas fa-users"></i></h4>
                              <p>สมาชิก</p>
                            </button>
                          </div>
                          <div className={`nav-link col px-1 py-0 ${activeTab === 'income' ? 'active' : ''}`}>
                            <button
                              className={`check-button w-100 d-block border-0 ${
                                activeTab === 'income' ? 'bgg-5 c-white' : 'bgc-4 c-dark'
                              }`}
                              onClick={() => setActiveTab('income')}
                            >
                              <h4><i className="fas fa-chart-bar"></i></h4>
                              <p>รายได้</p>
                            </button>
                          </div>
                          <div className={`nav-link col px-1 py-0 ${activeTab === 'topten' ? 'active' : ''}`}>
                            <button
                              className={`check-button w-100 d-block border-0 ${
                                activeTab === 'topten' ? 'bgg-5 c-white' : 'bgc-4 c-dark'
                              }`}
                              onClick={() => setActiveTab('topten')}
                            >
                              <h4><i className="far fa-thumbs-up"></i></h4>
                              <p>ท๊อปเท็น</p>
                            </button>
                          </div>
                        </div>
                      </div>
                      
                      <div className="col-12 px-1">
                        <div className="tab-content">
                          <div className={`tab-pane fade ${activeTab === 'overall' ? 'show active' : ''}`}>
                            {activeTab === 'overall' && <AffiliateOverallPage />}
                          </div>
                          <div className={`tab-pane fade ${activeTab === 'member' ? 'show active' : ''}`}>
                            {activeTab === 'member' && <AffiliateMemberPage />}
                          </div>
                          <div className={`tab-pane fade ${activeTab === 'income' ? 'show active' : ''}`}>
                            {activeTab === 'income' && <AffiliateIncomePage />}
                          </div>
                          <div className={`tab-pane fade ${activeTab === 'topten' ? 'show active' : ''}`}>
                            {activeTab === 'topten' && <AffiliateTopTenPage />}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default AffiliatePage
